import { useNavigate } from '@tanstack/react-router'
import { useFriends } from '../api/hooks'
import { BottomNav } from '../primitives'
import { FriendsIcon, GroupsIcon, HomeIcon, MeIcon, RecordPlusIcon } from './NavIcons'

/** A top-level tab destination. */
export type AppTab = 'home' | 'groups' | 'friends' | 'me'

/**
 * Persistent bottom tab bar for the app's top-level destinations. Render
 * it as the last child of a screen so its `position: sticky` pins it to
 * the bottom of the viewport.
 *
 * Four tabs flank a raised central record button: Home and Groups on the
 * left, Friends and Me on the right. The record hero sits dead center.
 */
export const AppNav = ({ active }: { active?: AppTab }) => {
  const navigate = useNavigate()
  const friends = useFriends()
  const incomingRequests = friends.data?.incoming.length ?? 0

  return (
    <BottomNav
      active={active}
      items={[
        { id: 'home', label: 'Home', icon: <HomeIcon />, onClick: () => navigate({ to: '/home' }) },
        {
          id: 'groups',
          label: 'Groups',
          icon: <GroupsIcon />,
          onClick: () => navigate({ to: '/groups' }),
        },
        {
          id: 'record',
          label: '',
          icon: <RecordPlusIcon size={24} />,
          hero: true,
          ariaLabel: 'Record a play',
          // Opens the scope picker — choose a group or just-friends.
          onClick: () => navigate({ to: '/record' }),
        },
        {
          id: 'friends',
          label: 'Friends',
          icon: <FriendsIcon />,
          badge: incomingRequests,
          onClick: () => navigate({ to: '/friends' }),
        },
        { id: 'me', label: 'Me', icon: <MeIcon />, onClick: () => navigate({ to: '/me' }) },
      ]}
    />
  )
}
